<template>
    <div class="midblock floatleft relative width100">
        <div class="padding15 textleft" v-if="cabinNumbers.options">
            <div
                v-if="isGuaranteeCabin(cabinNumbers.selected)"
                class="width100"
            >
                <div class="hutmelding garantiehut">
                    <p>
                        <b>Garantiehut</b><br />
                        Het gekozen huttype is een garantiehut. De garantiehut
                        is vaak het meest voordelige huttype. Hierbij kan je
                        geen hutnummer kiezen, het hutnummer zal de rederij
                        toewijzen tijdens het inschepen. Je hebt wel de garantie
                        dat dit ten minste een
                        {{ cabinName(cabin.naam, cabin.code) }} zal zijn. Wil je
                        toch graag een hutnummer kiezen, dan kan je in stap 3
                        een andere type hut of tarief selecteren.
                    </p>
                </div>
            </div>

            <div
                v-else-if="
                    cabinNumbers.options.length === 1 &&
                        !isGuaranteeCabin(cabinNumbers.selected)
                "
                class="width100 floatleft" style="width:calc(100% - 100px);"
            >
                <div class="hutmelding hutselectie" style="margin-bottom:0;">
                    <p>
                        Dit is de laatste {{ cabin.naam }} in deze
                        prijscategorie, hierdoor is een hutnummer keuze niet
                        meer mogelijk.
                      <span>Bekijk <b><u  v-on:click="toggleDeckMap()">hier je hutnummer op het dekkenplan</u></b></span>
                    </p>



                    <div class="clearfix"></div>
                </div>
            </div>

            <div
                v-else-if="
                    deckMap && deckMap.html !== '' && deckMap.html !== null
                "
                class="hutmelding hutselectie"
            >
                <p>
                    Voor het gekozen huttype {{ cabin.naam }} mag je kostenloos
                    een eigen hutnummer kiezen. Dit huttype is beschikbaar op
                    dek {{ deckNumberString(cabin.faciliteiten.dek) }}. Kies het
                    dek waar je graag wilt verblijven om de beschikbare
                    hutnummers van de {{ cabin.naam }} te zien.
                </p>



                <div class="clearfix"></div>
            </div>
          <div v-else-if="(!deckMap || deckMap.html === '' || deckMap.html === null) && cabinNumbers.options.length > 1" style="width:calc(100% - 100px);float:left">
            <div style="display: flex;line-height: 35px;">
              <b>Kies hier je hutnummer:</b>
              <div class="select-drop" style="margin-inline:10px;">
                <select
                    v-model="cabinNumbers.selected"
                    v-on:change="$emit('getDeckMap-click')"
                >
                  <option
                      v-for="(option,
                                            index) in cabinNumbers.options"
                      :key="'CabinNumberSelect' + index"
                      :value="option"
                  >
                    {{ option }}
                  </option>
                </select>
              </div>

            </div>
          </div>


          <div v-if="deckMap && deckMap.html !== '' && deckMap.html !== null && cabinNumbers.options.length > 1" style="width:calc(100% - 100px);float:left" class="childflexmobile">
            <div style="display: flex;line-height: 35px;">
              <b>Kies hier je hutnummer:</b>
              <div class="select-drop" style="margin-inline:10px;">
                <select
                    v-model="cabinNumbers.selected"
                    v-on:change="$emit('getDeckMap-click')"
                >
                  <option
                      v-for="(option,
                                            index) in cabinNumbers.options"
                      :key="'CabinNumberSelect' + index"
                      :value="option"
                  >
                    {{ option }}
                  </option>
                </select>
              </div>
              <span>Of <b><u  v-on:click="toggleDeckMap()">kies hier je hutnummer op het dekkenplan</u></b></span>

            </div>
          </div>

            <button
                v-on:click="$emit('cabinNumberSelect-click')"
                id="testCabinNumberSelect"
                class="btn btn-success btn-addon font14 bold floatright "
            >
                Ga door
            </button>

            <div class="clearfix"></div>
        </div>
        <div v-else-if="cabinNumbers.notAvailable" class="padding20 textleft red-notification">

         Het geselecteerde tarief is helaas niet beschikbaar met het geselecteerde reisgezelschap. <br>
           Wijzig je reisgezelschap of het tarief.

        </div>
      <div v-else="" class="padding20 textleft">
            <center>
                <font-awesome-icon icon="spinner" :spin="true" /> Bezig met
                ophalen van hutnummers...
            </center>
        </div>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

library.add(faSpinner)

export default {
    name: 'CabinNumberSelect',
    props: {
        cabinNumbers: Object,
        cruise: Object,
        cabin: Object,
        deckMapRecieved: Object,
        cabinName: Function,
        displayCabinNumber: Function,
        isGuaranteeCabin: Function,
        toggleDeckMap: Function,
        deckMap: Object,
    },
    data: function() {
        return {
            floorPlanVisible: false,
        }
    },
    methods: {
        showParam: function(key, value) {
            if (value === '' || value === 'N' || value === '0') return false
            if (key === 'dek' || key === 'oppervlakte' || key === 'usps')
                return false
            return true
        },
        faciliteitenToString: function(faciliteiten) {
            let retArr = []
            for (let [key, value] of Object.entries(faciliteiten)) {
                if (this.showParam(key, value)) {
                    retArr.push(key)
                }
            }
            return retArr.join(', ')
        },
        capitalize: function(s) {
            return s[0].toUpperCase() + s.slice(1)
        },
        deckNumberString: function(deckNumber) {
            return deckNumber
                .replace(/,([^,]*)$/, ' en ' + '$1')
                .replace(/,/g, ', ')
        },
        toggleFloorPlan: function() {
            if (this.floorPlanVisible) {
                this.floorPlanVisible = false
            } else {
                this.floorPlanVisible = true
            }
        },
        returnCorrectImage: function(cabin) {
            if (this.floorPlanVisible) {
                return cabin.img_plattegrond_url
            }
            return cabin.img_url
        },
        returnCorrectAction: function() {
            if (this.floorPlanVisible) {
                return 'Hut'
            } else {
                return 'Plattegrond'
            }
        },
    },
}
</script>

<style lang="scss">
$break-mobile: 740px;

.cabin_number-header {
    font-size: 14pt !important;
}

.hutmelding {
    margin-bottom: 20px;

    > p {
        margin: 10px;
    }
}

.garantiehut {
    background-color: #f8f8f8;
    border: #ddd solid 1px;
}

.hutselectie {
    display: table;
    //background-color: #c1efae;
    //border: #9add7e solid 1px;

    p {
        float: left;
        padding-right: 10px;
    }

    .button-wrapper {
        display: table-cell;
        vertical-align: middle;

        button {
            color: #fff;
            background-color: #999;
            font-size: 0.9em !important;
            display: block;
            width: 175px;
            margin: 10px;
        }
    }
}

.cabin_section {
    width: 100%;

    .cabin_images {
        height: 150px;
        overflow: hidden;
        float: left;
        margin-right: 15px;
        border-radius: 5px 5px 5px 5px;

        img {
            height: 100%;
        }

        .view_map_button {
            position: absolute;
            bottom: 5px;
            left: 5px;
            border-radius: 3px;
            padding: 3px 7px;
            font-weight: bold;
            background-color: #fff;
            color: #000;
            font-size: 12px;
            cursor: pointer;
            -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);
            box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);

            &:hover {
                text-decoration: underline;
            }
        }
    }

    .cabin_info {
        margin-left: 250px;

        > h4 {
            margin: 0;
            color: #2178b3;
        }

        > span {
            font-size: 0.9em;
        }
    }

    @media only screen and (max-width: $break-mobile) {
        .cabin_info {
            margin-left: 0;
        }
    }

}
.flexcabin {
  display: flex;
  .cabin_images {
    margin-right:0;
    width: 150px !important;
    border-radius: 5px 0 0 5px;
    height: 100px !important;
  }

  .midblock {
    border-radius: 0 5px 5px 0;
    height: 100px;

    .padding20 {
      display: flex;
      flex-flow: row;
      @media only screen and (max-width: 1200px) {
      & > div {
        flex-flow:column;
      }
      }
    }
  }
  margin-bottom: 10px;
}
@media only screen and (max-width: 1200px) {
  .childflexmobile {
    width:100% !important;
  }
  .childflexmobile + button {
    width:100%;
  }
  .childflexmobile > div {
    flex-flow:column;
  }
  .cabin_section {
    .cabin_images {
      aspect-ratio: 7/5;
      height:initial!important;
    }
  }
  .flexcabin {
    .midblock {
      padding-inline: 10px;
      width: calc(100% - 20px) !important;
      .padding20 {
        height:initial !important;
        padding-bottom:30px;
      }
    }
    .cabin_section {

      .cabin_images {
        display:block;
        width:100% !important;
        aspect-ratio: 2/1;
        height: auto !important;
        img {
          width: 100%;
        }
      }
    }
  }
  .midblock {
    b + div {
      flex-flow:column !important;
    }
  }
  .cabin-container-vertical .midblock {
    height:initial;

    .padding20, .padding20 div, .padding20 div div {
      text-align: left !important;
      width:calc(100% - 40px);

    }
    .width100 {
      width:100%;
      max-width:300px;
    }
    h2 {
      text-align: left !important;
    }
  }

}
</style>

